import React, { useState, useEffect } from 'react';
import './NotificationModal.css'; // Archivo CSS
import { capitalize } from '../common/capitalize';

const NotificationModal = ({ userId, notifications, isModalOpen, toggleModal, isAdmin, onViewAll, handleNotificationClick }) => {
    const [isFullyLoaded, setIsFullyLoaded] = useState(false);
    const [isClosing, setIsClosing] = useState(false);

    useEffect(() => {
        if (isModalOpen) {
            setIsFullyLoaded(true);
            setIsClosing(false);
        } else if (isFullyLoaded) {
            setIsClosing(true); // Set closing state
            setTimeout(() => {
                setIsFullyLoaded(false); // Unmount after transition
                setIsClosing(false);
            }, 300); // Match CSS transition duration
        }
    }, [isModalOpen]);


    if (!isModalOpen && !isFullyLoaded) {
        return null; // Prevent rendering if modal isn't open yet
    }

    const formatDate = (dateString) => {
        const options = { month: 'numeric', day: 'numeric', year: 'numeric' };
        const date = new Date(dateString);
        const localDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
        return localDate.toLocaleDateString(undefined, options);
    };

    const getCustomMessage = (notification) => {
        switch (notification.type) {
            case 'Ticket':
                return `A new ticket has been created on ${formatDate(notification.creationDate)} by ${capitalize(notification.fullname)}`;
            case 'Work Schedule':
                return `You have an update to your schedule created on ${formatDate(notification.creationDate)}`;
            case 'Inventory':
                return (notification.fullname === "undefined" || notification.fullname === "Unknown")
                    ? `An equipment has been moved to Inventory by Admin ${formatDate(notification.creationDate)}`
                    : `The Equipment or employee information of ${capitalize(notification.fullname)} has been updated by the Admin on ${formatDate(notification.creationDate)}`;
            case 'alert':
                return 'You have received an important alert.';
            case 'reminder':
                return 'This is a friendly reminder.';
            default:
                return 'You have a new notification.';
        }
    };

    const newNotifications = notifications.filter((n) => {
        const validStatus = Array.isArray(n.status)
            ? n.status.filter((id) => id && id !== 'n/a' && id !== '0000')
            : [];
        return !validStatus.includes(userId);
    });

    const readNotifications = notifications.filter((n) => {
        const validStatus = Array.isArray(n.status)
            ? n.status.filter((id) => id && id !== 'n/a' && id !== '0000')
            : [];

        return n.active === true && validStatus.includes(userId);
    });
    
    console.log("📦 Notificaciones leídas activas:", readNotifications.map(n => ({
        id: n.id,
        type: n.type,
        relatedId: n.relatedId,
        active: n.active,
        status: n.status,
        readByUser: Array.isArray(n.status) && n.status.includes(userId),
      })));



    return (
        <div className={`modal-notification-overlay ${isClosing ? 'closed' : isFullyLoaded ? 'open' : ''}`}
            onClick={(e) => {
                if (e.target.classList.contains("modal-notification-overlay")) {
                    toggleModal();
                }
            }}
        >
            <div className="modal-notification-content" onClick={(e) => e.stopPropagation()}>
                <h3>Notifications</h3>
                <div className="notification-messages">
                    {notifications.length > 0 ? (
                        <>
                            <div className="notifications-section">
                                <h3 className="section-title">New Notifications</h3>
                                {newNotifications.length > 0 ? (
                                    newNotifications.map((notification) => (
                                        <div
                                            key={notification.relatedId}
                                            className="notification-item unread"
                                            onClick={() => handleNotificationClick(notification)}
                                        >
                                            {getCustomMessage(notification)}
                                        </div>
                                    ))
                                ) : (
                                    <p className="no-notifications">No available new notifications</p>
                                )}
                            </div>

                            <div className="notifications-section">
                                <h3 className="section-title">Earlier</h3>
                                {readNotifications.length > 0 ? (
                                    readNotifications.map((notification) => (
                                        <div
                                            key={notification.relatedId}
                                            className="notification-item read"
                                            onClick={() => handleNotificationClick(notification)}
                                        >
                                            {getCustomMessage(notification)}
                                        </div>
                                    ))
                                ) : (
                                    <p className="no-notifications">No available earlier notifications</p>
                                )}
                            </div>

                        </>
                    ) : (
                        <p className="no-notifications">No notifications available</p>
                    )}
                </div>

                {notifications.length > 0 && (
                    <p className="notification-intro">
                        You have a new message! Please check it as soon as possible.
                    </p>
                )}
                <button className="close-notification-button" onClick={toggleModal}>
                    Close
                </button>
                {isAdmin && (
                    <button className="close-notification-button" onClick={onViewAll}>
                        View All Notifications
                    </button>
                )}
            </div>
        </div>
    );
};

export default NotificationModal;
